<div class="wrappers">
  <Figure [ngClass]="selectedId === i? 'active' : ''" *ngFor = "let image of images ; index as i" (click)="onClick(i)">
    <div class="icon-background">
      <div [ngClass] = "i == 0 ? 'table' : 'form'"></div>
    </div>
    <h3>{{texts[i]}}</h3>
    <p>{{instructions[i]}}</p>
  </Figure>
</div>
